import styled from 'vue-styled-components';
import { FONTS } from '@shared/constants';
import { COLORS, SUMMARY_BAR_COLORS } from '@shared/colors';

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 10px 10px 0px 10px;
  background-color: ${COLORS.WHITE};
  border-top: 1px solid ${SUMMARY_BAR_COLORS.BORDER};
  margin: 0px;
  text-transform: capitalize;
  max-height: 120px;
  overflow-y: auto;
`;

export const FilterButton = styled.button`
  display: inline-block;
  border: 1px solid ${SUMMARY_BAR_COLORS.BORDER};
  background-color: ${COLORS.WHITE};
  border-radius: 5px;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 10px 10px 10px 10px;
  font-family: ${FONTS.KNOCKOUT_32_FONT};
  font-weight: 400;
  font-size: 19.2px;
  line-height: 1.2em;
`;

export const ClearButton = styled(FilterButton)`
  font-size: 1.2em;
  line-height: 1.15;
  background-color: ${({ theme }) => theme.mainColor};
  color: ${COLORS.WHITE};
  cursor: pointer;
  border-top: 2px solid ${SUMMARY_BAR_COLORS.CLEAR_LIGHT};
  border-left: 2px solid ${SUMMARY_BAR_COLORS.CLEAR_LIGHT};
  border-right: 2px solid ${SUMMARY_BAR_COLORS.CLEAR_DARK};
  border-bottom: 2px solid ${SUMMARY_BAR_COLORS.CLEAR_DARK};
`;

export const ButtonLabel = styled.span`
  color: ${SUMMARY_BAR_COLORS.BUTTON_LABEL};
  margin-right: 5px;
`;

export const ButtonValue = styled.span`
  color: ${({ theme }) => theme.mainColor};
`;
